<web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()" />

<div class="panel-options-body overflow-wrapper">
    <form class="form form-horizontal" (submit)="$event.preventDefault()">
        <div class="form-row">
            <div class="form-group mb-10">
                <div class="col-xs-12 device-toggle-wrapper">
                    <web-device-toggle />

                    <web-synchronize-style-toggle
                        [active]="form.isSyncedWithDesktop()"
                        (click)="toggleSyncWithDesktop()"
                    />
                </div>
            </div>
        </div>

        <div class="form-group mb-0">
            <p class="col-xs-12 help-block text-muted small">
                {{ deviceHint() | translate }}
            </p>
        </div>

        <div class="form-group">
            <label class="col-xs-7 control-label">
                {{ "control_indent_height" | translate }}
            </label>
            <div class="col-xs-5">
                <sp-input-num
                    suffixText="px"
                    [min]="SIZE_MIN"
                    [value]="heightValue()"
                    (valueChange)="setHeightValue($event)"
                />
            </div>
        </div>

        <div class="mt-20">
            <web-custom-id [displayId]="form?.displayId()" (valueChangeEvent)="form?.setDisplayId($event)" />
        </div>
    </form>
</div>
